import { buildsServiceApi } from "../../api";
import {
  GetObjectRequest,
  GetObjectResponse,
} from "../../api/object/types";

export const getObject = async (
  data: GetObjectRequest,
): Promise<GetObjectResponse> => {
  const response = await buildsServiceApi.get(
    `building-objects/${data.objectId}`,
  );
  return response.data;
};
